// صفحة التتبّع — المرحلة الأولى (صحّة المعلومات والخصوصيّة) — 2026-10-18.
const EN_B12: Record<string, string> = {
  " + اسم السائق": " + driver name",
  " + اسم المستأجر": " + renter name",
  " + هاتف المستأجر": " + renter phone",
  "إيقاف مؤقت": "Pause",
  "اسم السائق": "Driver name",
  "التشغيل من البداية": "Play from start",
  "الفترة المعروضة": "Shown period",
  "انتهت الجلسة — سجّل الدخول من جديد": "Session expired — sign in again",
  "بتوقيت الكويت": "Kuwait time",
  "بداية الفترة يجب أن تسبق نهايتها": "The start must be before the end",
  "بدون أي بيانات شخصية": "no personal data",
  "تاريخ أو وقت غير صالح": "Invalid date or time",
  "تسجيل لا بث مباشر": "recording, not live",
  "تعذر الاتصال بالخادم": "Couldn't reach the server",
  "تعذر التحديث — آخر بيانات قبل": "Update failed — last data",
  "تعذر التحميل": "Couldn't load",
  "تعذر النسخ — انسخ الرابط يدوياً من الخانة": "Couldn't copy — copy the link from the box manually",
  "تعذر تحميل الخريطة — قائمة الأسطول تعمل، أعد تحميل الصفحة لاحقاً لعرض الخريطة": "The map couldn't load — the fleet list still works; reload later to show the map",
  "تعذر جلب الأسطول": "Couldn't load the fleet",
  "تعذر جلب الرحلات": "Couldn't load trips",
  "تعذر جلب سجل الروابط": "Couldn't load the links log",
  "تعذر جلب مسار الفترة — حاول مرة أخرى": "Couldn't load the route for this period — try again",
  "جاري تحميل الأسطول…": "Loading fleet…",
  "جاري تحميل الرحلات…": "Loading trips…",
  "جاري تحميل مسار الفترة…": "Loading route…",
  "حالة تأجير غير معروفة": "Rental status unknown",
  "حاول مرة أخرى": "try again",
  "خارج / غير متاحة": "Out / unavailable",
  "رقم صاحب العقد": "Contract holder's number",
  "سائق السيارة الخارجة (ليس مستأجراً)": "Driver of the car that's out (not a renter)",
  "سيرى المستلم: اسم السيارة ولوحتها والمسار والسرعة في هذه الفترة فقط — بدون بيانات المستأجر. صلاحية الرابط أسبوع.": "The recipient sees the car name, plate, route and speed for this period only — no renter data. The link is valid for a week.",
  "سيُشارَك": "Sharing",
  "صاحب العقد الحالي": "Current contract holder",
  "كم/س الآن": "km/h now",
  "لا توجد أجهزة تتبع مرتبطة بالشركة": "No tracking devices are linked to this company",
  "لا رحلات في هذه الفترة": "No trips in this period",
  "مباشر · يتحدّث كل ١٥ث": "Live · updates every 15s",
  "مزالة من الأسطول": "Removed from fleet",
  "مسافة الفترة (كم)": "Period distance (km)",
  "مسح البحث والفلتر": "Clear search and filter",
  "مشاركة الفترة": "Share period",
  "مشاركة هذه الرحلة": "Share this trip",
  "يرى المستلم": "Recipient sees",
  "تعذر تحميل الخريطة — الرحلات والملخص متاحة": "The map couldn't load — trips and summary are still available",
  "ليس لديك صلاحية لهذا الإجراء": "You don't have permission for this action",
  "الخادم لم يستجب كما يجب": "The server didn't respond properly",
  "تعذر إنشاء رابط التتبع — حاول مرة أخرى": "Couldn't create the tracking link — try again",
  "تعذر تحديث الرابط — حاول مرة أخرى": "Couldn't update the link — try again",
  "تعذر إنشاء الرابط — حاول مرة أخرى": "Couldn't create the link — try again",
  "جاري تحميل الفترة…": "Loading period…",
  "لا رحلات مكتملة في هذه الفترة — حركة قصيرة فقط": "No completed trips in this period — short movements only",
  "قيادة": "driving",
  "ملخص الرحلة": "Trip summary",
  "مسافة الرحلة (كم)": "Trip distance (km)",
  "الرحلة": "Trip",
  "إظهارها": "Show it",
  "ابحث: سيارة، لوحة، مستأجر، عقد، هاتف، IMEI": "Search: car, plate, renter, contract, phone, IMEI",
  "الأدوات والتنبيهات": "Tools & alerts",
  "الإرجاع": "Return",
  "الاتجاهات": "Directions",
  "الازدحام المروري": "Traffic",
  "الحركة والاتصال": "Motion & connection",
  "السيارة المحددة مخفية بالفلتر الحالي — لا تُتابَع على الخريطة": "The selected car is hidden by the current filter — it isn't followed on the map",
  "الطبقات": "Layers",
  "المتابعة متوقفة": "Following paused",
  "بحث في الأسطول": "Search the fleet",
  "بطارية الجهاز منخفضة": "Device battery low",
  "بيانات قديمة — الموقع غير موثوق": "Old data — location not reliable",
  "تحتاج متابعة": "Needs follow-up",
  "تحديث الآن": "Refresh now",
  "تعديل بيانات الجهاز": "Edit device details",
  "تمركز على كل السيارات المعروضة": "Fit all shown cars",
  "سيارة خارجة — ليس مستأجراً": "car is out — not a renter",
  "عرض النتائج": "Show results",
  "فلاتر": "Filters",
  "مؤجَّرة والجهاز غير متصل": "Rented and the device is offline",
  "مؤجَّرة ولا إشارة GPS": "Rented with no GPS signal",
  "متابعة السيارة": "Follow car",
  "يتابع": "Following",
  "⛔ رسم منطقة محظورة": "⛔ Draw a restricted zone",
  "✕ إلغاء رسم المنطقة": "✕ Cancel zone drawing",
  "🌡️ سلسلة التبريد": "🌡️ Cold chain",
  "🔗 روابط التتبع": "🔗 Tracking links",
  "{n} من {m} مركبة": "{n} of {m} vehicles",
  "متأخرة {n} يوم": "Overdue {n} day(s)",
  "{i} من {n}": "{i} of {n}",
  "مدة الرحلة": "Trip duration",
  "مدة القيادة": "Driving time",
  "إزالة فلتر": "Remove filter",
  "تطبيق": "Apply",
  "ملخص": "Summary",
  "مخفية بالفلتر الحالي": "Hidden by the current filter",
  "كل التفاصيل والإجراءات": "All details and actions",
};
export default EN_B12;
